import {
  GetCopyFromOtherCustomerBreadCrumbNameQuery,
  GetCopyFromOtherCustomerBreadCrumbNameQueryVariables,
  GetCopyToCustomerQuery,
  GetCopyToCustomerQueryVariables,
} from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";

const getCopyFromOtherCustomerBreadCrumbNameQuery = gql`
  query GetCopyFromOtherCustomerBreadCrumbName($id: ID!) {
    productPrice {
      customers {
        byId(id: $id) {
          breadCrumbName
        }
      }
    }
  }
`;

export const useGetCopyFromOtherCustomerBreadCrumbNameQuery = (
  customerId: string
) => {
  const { data, loading } = useQuery<
    GetCopyFromOtherCustomerBreadCrumbNameQuery,
    GetCopyFromOtherCustomerBreadCrumbNameQueryVariables
  >(getCopyFromOtherCustomerBreadCrumbNameQuery, {
    variables: { id: customerId },
  });

  const breadCrumbName =
    data?.productPrice.customers.byId?.breadCrumbName ?? "";

  return { breadCrumbName, loading };
};

const getCopyToCustomerQuery = gql`
  query GetCopyToCustomer($customerId: ID!) {
    productPrice {
      customers {
        byId(id: $customerId) {
          id
          name
          custIndex
          custNo
        }
      }
    }
  }
`;

export const useGetCopyToCustomerQuery = (customerId: string) => {
  const { loading: customerLoading, data } = useQuery<
    GetCopyToCustomerQuery,
    GetCopyToCustomerQueryVariables
  >(getCopyToCustomerQuery, {
    variables: {
      customerId,
    },
    fetchPolicy: "network-only",
  });

  return { copyToCustomer: data?.productPrice.customers.byId, customerLoading };
};
